export default __webpack_public_path__ + "static/media/banner-sunum.9d822f5c.mp4";